import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import PageBlock from '@sharedCR/common/PageBlock';
import DOMPurify from 'dompurify';

import { selectSuspenseReason } from 'store/loanApplications/selectors';

import { UnderwritingTestIds } from '../Underwriting.testIds';

const SuspenseReason = () => {
  const suspenseReason = useSelector(selectSuspenseReason);

  const sanitizedSuspenseReason = useMemo(() => {
    if (!suspenseReason) {
      return;
    }

    const sanitizedHtml = DOMPurify.sanitize(suspenseReason, {
      WHOLE_DOCUMENT: true,
    });

    return { __html: sanitizedHtml };
  }, [suspenseReason]);

  if (!suspenseReason) {
    return null;
  }

  return (
    <PageBlock
      withDivider
      data-testid={UnderwritingTestIds.SUSPENSE_REASON_SECTION}
      title="Suspense Reason"
    >
      <Typography dangerouslySetInnerHTML={sanitizedSuspenseReason} variant="regular16" />
    </PageBlock>
  );
};

export default memo(SuspenseReason);
